import { KnowledgeDocumentVersion } from '@/types/knowledge';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface VersionContentProps {
  version: KnowledgeDocumentVersion;
}

export function VersionContent({ version }: VersionContentProps) {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <h1 className="text-2xl sm:text-3xl font-bold break-words">{version.title}</h1>
          <p className="text-muted-foreground mt-2">{version.category}</p>
        </div>
        <Badge variant="outline" className="shrink-0">v{version.version}</Badge>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Problema</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="whitespace-pre-wrap">{version.problem}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Solução</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="whitespace-pre-wrap">{version.solution}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Informações da Versão</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm">
          <div className="flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
            <span className="text-muted-foreground">Versão:</span>
            <span>v{version.version}</span>
          </div>
          <div className="flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
            <span className="text-muted-foreground">Protocolo:</span>
            <span className="font-mono text-xs break-all">{version.sourceProtocol}</span>
          </div>
          <div className="flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
            <span className="text-muted-foreground">Tipo:</span>
            <Badge variant={version.editedByUserId ? 'default' : 'secondary'} className="w-fit">
              {version.editedByUserId ? 'Manual' : 'Automático'}
            </Badge>
          </div>
          {version.editReason && (
            <div className="flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
              <span className="text-muted-foreground">Motivo da edição:</span>
              <span className="break-words">{version.editReason}</span>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
